import { useState } from "react";
import "./css/noticias.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Img1 from "../../images/liquidacionRep/img1.webp";
import { Server } from "../../constants";
import axios from 'axios';
import { Form, FormControl, InputGroup, Modal, ModalTitle } from 'react-bootstrap';
import { AiOutlineClose } from "react-icons/ai";
import { CartBuy } from "./CartBuy";
import Productos from "./Productos";
import cartIcon from "../../images/cartIcon.png";


const ListadoRepuestos = () => {
  const [yearCar, setYearCar] = useState("");
  const [modelosVehiculo, setModelosVehiculo] = useState([]);
  const [showModalCart, setShowModalCart] = useState(false);
  const [productsItem, setProductsItem] = useState([]);
  const [cartItems, setCatItems] = useState([]);

  const newAddProduct = (product) => {
    const ProductExist = cartItems.find((item) => item.id === product.id);
    if (ProductExist) {
      setCatItems(cartItems.map((item) => item.id === product.id ? { ...ProductExist, quantity: ProductExist.quantity + 1 } : item)
      );
    } else {
      setCatItems([...cartItems, { ...product, quantity: 1 }]);
    }
  };

  const minProduct = (product) => {
    const ProductExist = cartItems.find((item) => item.id === product.id);
    if (ProductExist.quantity === 1) {
      setCatItems(cartItems.filter((item) => item.id !== product.id))
    } else {
      setCatItems(
        cartItems.map((item) => item.id === product.id ? { ...ProductExist, quantity: ProductExist.quantity - 1 } : item)
      );
    }
  };

  const getModelos = (event) => {
    const value = event.target.value;
    if ((value !== '' && isNaN(Number(value))) || value.length > 4) {
      return;
    }
    setYearCar(value);
    obtenerModelosVehiculo(value);
  }

  const obtenerModelosVehiculo = async (value) => {
    if (String(value).length === 4) {
      try {
        const response = await axios.get(`${Server}/api/obsoletos/getObsoletosAnio/${value}`);
        setModelosVehiculo(response.data.data.map((modelo) => ({
          value: modelo.vehicle,
          label: modelo.description
        })));
      } catch (error) {
        console.error(error);
      }
    }
  };

  const getProductos = async (event) => {
    const value = event.target.value;
    try {
      const response = await axios.get(`${Server}/api/obsoletos/getObsoletosModel/${value}`);
      if (response) {
        setProductsItem(response.data.data.map((modelo) => ({
          id: modelo.id_part,
          img: Img1,
          name: modelo.description,
          price: modelo.cost,
        })));
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Container>
      <Row>
        <div className="grid-header-repuestos">
          <div className="grid-header-repuestos-uno" >
            <img src={cartIcon} alt="Carrito de compras" className="cart-icon" onClick={() => setShowModalCart(true)} />
            <p className="cart-icon-name" onClick={() => setShowModalCart(true)}>Carrito</p>
          </div>
          <div className="grid-header-repuestos-dos">
            <h1 className="Titulo-repeustos">LIQUIDACIÓN DE REPUESTOS</h1>
          </div>
        </div>
      </Row>
      <div className="Filtro-vehiculo">
        <h3>Seleccione su vehiculo</h3>
      </div>
      <Row>
        <Col>
          <div>
            <div>
              Coloque el año:
            </div>
            <div>
              <form action="" className="input-year">
                <InputGroup>
                  <FormControl
                    type="text"
                    value={yearCar}
                    placeholder="Año de fabricación"
                    onChange={getModelos}
                  >
                  </FormControl>
                </InputGroup>
              </form>
            </div>
          </div>
        </Col>
        <Col>
          <div>
            <Form>
              <Form.Label >Seleccione el modelo: </Form.Label>
              <FormControl as="select" name="Modelo" onChange={getProductos}>
                <option value="">Seleccione modelo del vehículo</option>
                {modelosVehiculo.map((modelo, index) => (
                  <option key={index} value={modelo.value}>{modelo.label}</option>
                ))}
              </FormControl>
            </Form>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div>
            <Form>
              <Form.Label>Seleccione la versión: </Form.Label>
              <FormControl as="select" Label="Versión" >
              </FormControl>
            </Form>
          </div>
        </Col>
        <Col>
          <Form>
            <Form.Label>Ingrese el código de parte: </Form.Label>
            <InputGroup >
              <FormControl
                className=""
                placeholder={"4597521"}
                type="text"
              >
              </FormControl>
            </InputGroup>
          </Form>
        </Col>
      </Row>
      <br />
      <Productos
        productsItem={productsItem}
        newAddProduct={newAddProduct}
        minProduct={minProduct}
      ></Productos>
      <Modal size="xl" show={showModalCart}>
        <Modal.Header>
          <ModalTitle>
            <div className="grid-header-modal">
              <div className="grid-header-modal-uno" >
                Cart Items:
              </div>
              <div className="grid-header-modal-dos">
                <AiOutlineClose className="cart-close" onClick={() => { setShowModalCart(false) }} />
              </div>
            </div>
          </ModalTitle>
        </Modal.Header>
        <Modal.Body>
          <CartBuy
            cartItems={cartItems}
            newAddProduct={newAddProduct}
            minProduct={minProduct}
          ></CartBuy>
        </Modal.Body>
      </Modal>
    </Container>
  )
}
export default ListadoRepuestos;